import React, { useEffect, useState } from 'react';
import './App.css';
import Nav from './components/Nav';
import Hero from './components/Hero';
import WhatIDo from './components/WhatIDo';
import SelectedWork from './components/SelectedWork';
import BKKButterBento from './components/BKKButterBento';
import NancreatedBento from './components/NancreatedBento';
import About from './components/About';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Marquee from './components/Marquee';
import CommandPalette from './components/CommandPalette';

function App() {
  const [cmdOpen, setCmdOpen] = useState(false);

  useEffect(() => {
    document.title = 'Sirin Thamakaison · builder, operator, storyteller';
  }, []);

  return (
    <div className="App grain" style={{ background: 'var(--bone)' }}>
      <Nav onOpenCommand={() => setCmdOpen(true)} />
      <main>
        <Hero />
        <Marquee />
        <WhatIDo />
        <SelectedWork />
        {/* Anchor so nav "#practice" still lands at the start of the two bentos */}
        <div id="practice" style={{ scrollMarginTop: '4rem' }} />
        <BKKButterBento />
        <NancreatedBento />
        <About />
        <Contact />
      </main>
      <Footer />
      <CommandPalette open={cmdOpen} setOpen={setCmdOpen} />
    </div>
  );
}

export default App;
